import _ from "lodash";
import { useEffect, useState } from "react";
import parseWhatsAppText from "../utils/WhatsappFormatter";
import { Typography } from "@mui/material";
import parse from 'html-react-parser';

const replaceVariables = ({ text = '', variables }) => {
    if (_.isEmpty(text) || _.isEmpty(variables)) {
        return text;
    }
    let resolvedText = text;
    variables?.forEach(v => {
        if (!_.isEmpty(v.example)) {
            resolvedText = resolvedText.replace(`{{${v.param_name}}}`, v.example);
        }
    });
    return resolvedText;
}

export const TextPreview = ({ component, getTextHandler, examples, fontWeight = 500, fontSize }) => {

    const [textComponents, setTextComponents] = useState();

    useEffect(() => {
        const resolvedContent = replaceVariables({ text: getTextHandler(component), variables: examples });
        const parsedWhatsappTokens = parseWhatsAppText(resolvedContent);
        setTextComponents(parsedWhatsappTokens);
    }, [component]);

    return (
        <Typography variant="whatsapp-template-content" fontWeight={fontWeight} fontSize={fontSize}>
            {!_.isEmpty(textComponents) && parse(textComponents)}
        </Typography>
    );

};

export const ImagePreview = ({ component, getUrlHandler }) => {

    const [url, setUrl] = useState();

    useEffect(() => {
        getUrlHandler(component).then(res => setUrl(res));
    }, [component]);

    return (
        <img src={url} height={150} width={250} />
    );
};

export const ContentPreviewFactory = {
    'text': TextPreview,
    'image': ImagePreview,
};